import { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { ShoppingBag, Smartphone, KeyRound, Building2, User, MapPin } from 'lucide-react';
import { ImageWithFallback } from './ImageWithFallback';
import { CallAPIPromise } from '../routeBilling/menu/dashboard/biiling/modal/comman';
import CryptoJS from 'crypto-js';
import { useDispatch } from 'react-redux';
import { setPrefix, setShopDetails } from '../utility/Redux/profile';
import { setSpinnerLoading } from '../utility/Redux/modal';
import SpinnerLoading from '../utility/component/modals/spinnerLoading';
import LogoComponent from '../utility/component/styles/logoComponent';
import logo from '../utility/images/icon2.svg';
import text from '../utility/images/text2.svg';
import { Toaster, toast } from 'sonner';
import { setToken } from '../utility/Redux/security';


export default function LoginPage({ onLogin }) {
  const [step, setStep] = useState("mobile")
  const [mobile, setMobile] = useState('');
  const [otp, setOtp] = useState('');
  const [companies,setCompnaies]=useState([])
const dispatch = useDispatch()
  const handleSendOtp = (e) => {
      e.preventDefault();
      const secretPass = process.env.REACT_APP_AUTH_SECRET_KEY;

      // const hmac = CryptoJS.HmacSHA256(message, secret);
      const hmac = CryptoJS.HmacSHA256(mobile, secretPass);
      // Convert the HMAC to a string and encode it using Base64
      const hmacString = hmac.toString(CryptoJS.enc.Base64);
    
    if (mobile.length === 10) {
      dispatch(setSpinnerLoading("Loading"))
      setOtp("")
          CallAPIPromise("/api/sendShopLoginOTP/send-shop-otp", {
              "type": "shop otp",
              "toPhoneNumber": mobile,
              "INVNO": "0",
              "AMOUNT": "0",
              "prefix": "go_",
              "template_for": "shop otp",
              "companyEmail": "balraj@geniusoffice.com",
              "message_for": "Login OTP",
              "rejected_reason": ""
          }, hmacString).then((res) => {
            // dispatch(setShopDetails(res.data.shop))
      setStep('otp');
              
          }).finally(() => {
          dispatch(setSpinnerLoading(false))
        })

      // CallAPIPromise('/api/shopkeeperMaster/listShopVendors', {
      //   mobile:mobile
      // }).then((res) => {
      //   if (res?.data?.shops)
      //     setCompnaies(res?.data?.shops)
      //   setStep("company")
      // }).finally(() => {
      //   dispatch(setSpinnerLoading(false))
      // })
    }
  };

  const handleVerifyOtp = (e) => {
    e.preventDefault();
    if (otp.length === 4) {
      dispatch(setSpinnerLoading("Loading"))

      CallAPIPromise('/api/sendShopLoginOTP/verifyOtp', {
        mobile: mobile,
        otp
      }).then((res) => {
        console.log(res)
        if (res?.data?.token) {
          dispatch(setToken(res.data.token))
          CallAPIPromise('/api/shopkeeperMaster/listShopVendors', {
            mobile:mobile
          }).then((res) => {
            if (res?.data?.shops)
              setCompnaies(res?.data?.shops)
            setStep("company")
          }).finally(() => {
            dispatch(setSpinnerLoading(false))
          })
        }
       
      }).catch((e) => {
       toast.error(e?.response?.data?.message||"Invalid otp")
        dispatch(setSpinnerLoading(false))
      })
    
    }
  };
const secretPass = process.env.REACT_APP_SECRET_KEY;

  const encryptData = (text) => {
    const data = CryptoJS.AES.encrypt(
      JSON.stringify(text),
      secretPass
    ).toString();
  
    localStorage.setItem('prefix', data);
  };
  const handleCompanySelect = (e) => {
    console.log(e)
    encryptData(e.table_prefix)
    dispatch(setPrefix(e.table_prefix))
    dispatch(setShopDetails(e))
      // onLogin();

  }

  return (
    <div className="min-h-screen flex items-center text-[18px] justify-center ">
    <div className="w-full max-w-md">
        {/* Hero Image Section */}
        <div className='flex justify-end mb-2'>
        <img
        src={logo}
        style={{
          height: 'px',
          width: '30px',
        }}
          />
           <img
        src={text}
        style={{
          height: 'px',
          width: '100px',
        }}
        className='ml-2'
      />
        </div>
      
      <div className="mb-8">
        <div className="relative w-full h-48 sm:h-56 rounded-3xl overflow-hidden shadow-2xl mb-6">
          <ImageWithFallback
            src="https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxzbWFsbCUyMHNob3AlMjBvd25lcnxlbnwxfHx8fDE3NjMxMjY0Njh8MA&ixlib=rb-4.1.0&q=80&w=1080"
            alt="Shopkeeper"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-blue-900/80 via-blue-900/40 to-transparent" />
          <div className="absolute bottom-0 left-0 right-0  text-white">
          
           
              

              <div className="flex items-center gap-2 mb-3 pl-4 pt-2">
              <div className="w-[70px] h-[70px] bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center">
                <ShoppingBag className="w-12 h-12" />
                </div>
                <div>
                <div className="text-white  font-semibold text-[24px]">ShopKeeper Pro </div>

                <div className="text-white/90 -mt-1 text-[16px] ">Your complete shop management solution</div>
              
                </div>
              </div>
           
          </div>
        </div>
      </div>

      <Card className="shadow-xl border-0">
        <CardHeader className="space-y-1">
          <CardTitle className="text-center">
            {step === 'mobile' && 'Welcome Back'}
            {step === 'otp' && 'Verify OTP'}
            {step === 'company' && `Select Company`}
          </CardTitle>
          <CardDescription className="text-center">
            {step === 'mobile' && 'Enter your mobile number to continue'}
            {step === 'otp' && `We've sent a code to ${mobile}`}
            {step === 'company' && 'Choose the company you want to manage'}
          </CardDescription>
        </CardHeader>
        <CardContent>
          {step === 'mobile' ? (
            <form onSubmit={handleSendOtp} className="space-y-4">
              <div className="space-y-2">
                <label htmlFor="mobile" className="flex items-center gap-2 text-gray-700">
                  <Smartphone className="w-4 h-4" />
                  Mobile Number
                </label>
                <Input
                  id="mobile"
                  type="tel"
                  placeholder="Enter 10-digit mobile number"
                  value={mobile}
                  onChange={(e) => setMobile(e.target.value.replace(/\D/g, '').slice(0, 10))}
                  className="h-14 text-[18px] "
                  maxLength={10}
                  required
                />
              </div>
              <Button 
                type="submit" 
                className="w-full h-12 bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700"
                disabled={mobile.length !== 10}
              >
                Send OTP
              </Button>
            </form>
          ) : step === 'otp' ? (
            <form onSubmit={handleVerifyOtp} className="space-y-4">
              <div className="space-y-2">
                <label htmlFor="otp" className="flex items-center gap-2 text-gray-700">
                  <KeyRound className="w-4 h-4" />
                  Enter OTP
                </label>
                <Input
                  id="otp"
                  type="tel"
                  placeholder="Enter 4-digit OTP"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
                  className="h-14 text-[18px] text-center tracking-widest"
                  maxLength={4}
                  required
                />
              </div>
              <Button 
                type="submit" 
                className="w-full h-12 bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700"
                disabled={otp.length !== 4}
              >
                Verify & Continue
              </Button>
              <Button 
                type="button" 
                variant="ghost" 
                className="w-full"
                onClick={() => setStep('mobile')}
              >
                Change Mobile Number
              </Button>
            </form>
          ) : (
            <div className="space-y-3 max-h-[400px] overflow-y-auto">
              {companies.map((company) => (
                <button
                  key={company.id}
                  onClick={() => handleCompanySelect(company)}
                  className="w-full p-4 border border-gray-200 rounded-lg hover:border-blue-500 hover:bg-blue-50 transition-all text-left group"
                >
                  <div className="space-y-2">
                    <div className="flex items-start justify-between">
                      <div className="flex items-center gap-2">
                        <div className="w-10 h-10 bg-gradient-to-br from-blue-600 to-indigo-600 rounded-lg flex items-center justify-center flex-shrink-0">
                          <Building2 className="w-5 h-5 text-white" />
                        </div>
                        <div>
                          <div className="text-gray-900 text-[23px] group-hover:text-blue-600">{company.company_name}</div>
                        </div>
                      </div>
                    </div>
                    
                  
                  </div>
                </button>
              ))}
            </div>
          )}

          {step === 'otp' && (
            <div className="mt-4 text-center">
              <button 
                className="text-blue-600 hover:underline"
                onClick={handleSendOtp}
              >
                Resend OTP
              </button>
            </div>
          )}

          {step === 'company' && (
            <div className="mt-4">
              <Button 
                type="button" 
                variant="ghost" 
                className="w-full"
                onClick={() => setStep('otp')}
              >
                Back to OTP
              </Button>
            </div>
          )}
        </CardContent>
        </Card>
        <SpinnerLoading />
        <Toaster position={"top-right"}/>

    
    </div>
  </div>
  );
}